module.exports = __webpack_public_path__ + "img/arrow_left.9c25e13c.svg";